import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth';

@Component({
  selector: 'app-admin-layout',
  standalone: false,
  templateUrl: './admin-layout.html',
  styleUrls: ['./admin-layout.css']
})
export class AdminLayout {
  sidebarOpen = false;

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  get adminName(): string {
    return this.authService.getAdminName();
  }

  get adminEmail(): string {
    return this.authService.getAdminEmail();
  }

  get isSuperAdmin(): boolean {
    return this.authService.isSuperAdmin();
  }

  toggleSidebar(): void {
    this.sidebarOpen = !this.sidebarOpen;
  }

  closeSidebar(): void {
    this.sidebarOpen = false;
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/auth/login']);
  }
}